import { Fragment } from 'react';
import type { ReactNode } from 'react';
import type { ReactNodeArray } from 'prop-types';
import reactStringReplace from 'react-string-replace';
import { _js } from '@ifixit/localize';

export function _jsr(orig: string, ...replacements: ReactNode[]): ReactNodeArray {
   const translated = _js(orig);
   return reactStringReplace(translated, /%(\d+)/g, (match, i) => {
      const matchInt = parseInt(match, 10);
      return isNaN(matchInt) || matchInt < 1 || matchInt > replacements.length ? (
         `%${match}`
      ) : (
         <Fragment key={i}>{replacements[matchInt - 1]}</Fragment>
      );
   });
}
